
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { LineChartIcon, PieChartIcon } from "lucide-react";
import PieChartDisplay from "../charts/PieChartDisplay";
import BarChartDisplay from "../charts/BarChartDisplay";

interface IncidentenTabProps {
  incidentsData: any[];
  monthlyIncidents: any[];
}

const IncidentenTab: React.FC<IncidentenTabProps> = ({
  incidentsData,
  monthlyIncidents
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Incidenten per type</CardTitle>
            <CardDescription>Verdeling van incidenttypes</CardDescription>
          </div>
          <PieChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <PieChartDisplay data={incidentsData} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Incidenten trend</CardTitle>
            <CardDescription>Aantal incidenten over tijd</CardDescription>
          </div>
          <LineChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <BarChartDisplay
            data={monthlyIncidents}
            dataKey="incidents"
            barName="Aantal incidenten"
            nameKey="month"
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default IncidentenTab;
